'use strict'

angular.module('rmTrashcan')
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('trashcan', {
                url: '/trashcan',

                views: {
                    'trashcanoverview': {
                        templateUrl: '/partial/app.partials.trashcan.overview',
                        controller: 'TrashcanOverviewCtrl',
                        controllerAs: 'trashcanCtrl',
                    },
                },

                onEnter: ['bladesManager', (bladesManager) => {

                    bladesManager.clearAll()
                    bladesManager.insert({ viewName: 'trashcanoverview', size: 'half' })
                }],
            })

    }])

